<template>
    <div class="main">
      <message-head type="success" title="支付成功">
        <span v-show="order.parkingSpotId">请联系保安取走您的车辆</span>
        <span v-show="!order.parkingSpotId">直接驶离 自动开闸</span>
      </message-head>
      <van-row class="number-pannel">
        <van-col span="12">
          <div class="number-pannel-title">停车单号</div>
          <div class="number-pannel-content">{{order.orderId}}</div>
        </van-col>
        <van-col span="12">
          <div class="number-pannel-title">此时间前离场免费</div>
          <div class="number-pannel-content">{{timeout}}</div>
        </van-col>
      </van-row>
      <van-notice-bar v-if="order.parkingSpotId" color="#1989fa" background="#ecf9ff" left-icon="info-o">
        请在免费时间前取车,若超时将重新锁定计费
      </van-notice-bar>
      <van-notice-bar v-else left-icon="info-o">
        请在以上时间之前驶离停车场,超时可能产生费用
      </van-notice-bar>
      <van-cell-group>
        <van-cell :title="order.parkingTime|duration" title-class="cell-title" :value="order.actualCharge+'元'" />
        <van-cell :title="order.parkingLotName" title-class="cell-title" :value="order.parkingSpotName || order.plateNumber || '无牌车'" />
      </van-cell-group>
      <br/>
      <van-row type="flex" justify="space-around">
        <van-col span="10"><van-button round block @click="close" v-if="isMiniProgram">关闭</van-button></van-col>
        <van-col span="10"><van-button type="primary" round block to="/orders?status=1">查看停车记录</van-button></van-col>
      </van-row>
      <br />
      <popularize v-if="order.orderId" :orderId="order.orderId" spaceId="618823441406222336" class="popular"/>
      <van-popup v-model="showYunzong" closeable>
        <a :href="yunzong.landingPage" v-if="yunzong">
          <img :src="yunzong.creativeImg.creativeUrl" style="max-width: 300px"/>
        </a>
      </van-popup>
    </div>
</template>

<script>
import { Button, Cell, CellGroup, Col, Collapse, CollapseItem, Icon, NoticeBar, Popup, Row } from 'vant';
import axios from "axios";
import qs from 'query-string';
import MessageHead from '../components/MessageHead.vue';
import { router } from '../router';
import dayjs from 'dayjs';
import PopularizeVue from '../components/Popularize.vue';

export default {
  components: {
    [Icon.name] : Icon,
    [Cell.name] : Cell,
    [CellGroup.name] : CellGroup,
    [Collapse.name] : Collapse,
    [CollapseItem.name] : CollapseItem,
    [Button.name] : Button,
    [Row.name] : Row,
    [Col.name] : Col,
    [NoticeBar.name] : NoticeBar,
    [Popup.name] : Popup,
    'message-head' : MessageHead,
    'popularize' : PopularizeVue
  },
  data() {
    return {
      order: {},
      timeout: '',
      showYunzong: false,
      yunzong: null,
      isMiniProgram: false
    }
  },
  beforeDestroy(){
    clearInterval(this.timer);
  },
  mounted() {
    const q = qs.parse(location.search);
    let { orderId } = q;
    const that = this;
    this.$wechat.sdk(sdk => {
        sdk.miniProgram.getEnv(function(res) {
          that.isMiniProgram = res.miniprogram;
        })
    });
    if (orderId) {
      this.$http.get('/order', {orderId}).then(function(order) {
        if (order && order.parkingStatus == 1){
          that.checkOrder(order);
        }
        else if (order && order.parkingStatus == 0){
          router.push('/parking?orderId='+order.orderId);
        }
        else {
          router.push('/orders');
        } 
      });
    } else {
      const that = this;
      this.$http.get('/member/parking_status').then(function(status){
        if (status.parkingStatus == 1){
          that.$http.get('/order', {orderId: status.parkingOrderId}).then(function(order) {
            that.checkOrder(order);
          });
        }
        else if (status.parkingStatus == 0){
          router.push('/parking?orderId='+status.parkingOrderId);
        }
        else {
          router.push('/orders');
        } 
      });
    }
    
  },
  methods: {
    checkOrder(order) {
      this.order = order;
      this.timeout = dayjs(order.endTime).add(order.leavingTimeout, 'second').format('HH:mm:ss');

      this.$http.get('/popularize/fetch_yunzong_popularize', {orderId: order.orderId, spaceId: '598483661242798080'}).then(resp => {
        this.yunzong = resp;
        this.showYunzong = !!resp;
        if (resp.trackUrl) {
          resp.trackUrl.forEach(url => {
          axios({ method: 'GET', url })
          });
        }
      })
    },
    scan() {
        router.push('/scan');
    },
    close() {
      this.$wechat.sdk(sdk => sdk.closeWindow());
    }
  }
};
</script>

<style lang="less" scoped>
  .number-pannel {
    text-align: center;
    background-color: white;
    padding: 10px;
  }
  .number-pannel-title {
    color: gray;
  }
  .number-pannel-content {
    color: green;
    font-size: 30px;
    padding: 10px 0
  }
  .cell-title {
    color: gray;
  }
  .tips {
    color: gray;
    font-size: 12px;
    margin: 10px;
  }
</style>